const InformationPage = () => import('@/views/Application/InformationPage/InformationPage');
const JobStatus = () => import('@/views/Application/Profile/JobStatus');

export default [
  {
    path: '/dashboard/information/:information/:code',
    name: 'information',
    component: InformationPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/information/job-status',
    name: 'information-job-status',
    component: JobStatus,
    meta: {
      requiresAuth: true,
    },
  },
];
